export enum eVendorStatus {
  active = 'active',
  inactive = 'inactive'
}
